module.exports = "<div class=\"gmw-statement__total gmw-statement__total--section-total\"> <span class=gmw-statement__total-label ng-transclude> </span> <span class=gmw-statement__total-data> <span class=\"gmw-statement__total-amount heading-h1\" ng-bind=amount.amount|gmwFormatNumber> </span> <span class=\"gmw-statement__total-currency heading-h6\" ng-bind=amount.currency> </span> </span> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/overview/directives/statement-total/statement-total.html
// module id = 769
// module chunks = 0